import { forwardRef, PropsWithChildren } from 'react';
import styles from './DropdownContainer.css';

export const DropdownContainer = forwardRef<HTMLDivElement, PropsWithChildren>(function DropdownContainer(
  { children },
  ref,
) {
  return (
    <div className={styles['dropdown']} ref={ref}>
      {children}
    </div>
  );
});
